import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ListParameters, ListResponse, transformParameters } from 'src/app/api';
import { SORT_ASC } from 'src/app/ui';
import { ValueLabel } from '../../shared/models/ValueLabel';
import { Event } from './event.model';

interface EventListFilter {
    employeesIDs: Array<number>;
    range: number;
    from: string;
    to: string;
    type: Array<string>;
    isDashboard?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class EventService {
    public constructor(private _http: HttpClient) { }

    public getEventsList(params: ListParameters<Event>, filter?: EventListFilter): Observable<ListResponse<Event>> {
        let parameters = transformParameters(params);

        if (filter) {
            parameters = {
                ...parameters,
                employeesIDs: filter.employeesIDs,
                range: filter.range,
                from: filter.from,
                to: filter.to,
                isDashboard: filter.isDashboard,
                type: filter.type,
            };
        }

        return this._http.post<ListResponse<Event>>('/api/events/list', parameters);
    }

    public getEventTypes(): Observable<ValueLabel[]> {
        return this._http.get<ValueLabel[]>('/api/events/categories');
    }

    public getLastX(count: number): Observable<Array<Event>> {
        const params: ListParameters<Event> = {
            itemsPerPage: count,
            page: 1,
            search: null,
            sort: {
                column: 'event_date',
                direction: SORT_ASC
            }
        };

        return this.getEventsList(params)
            .pipe(map(response => response.data));
    }
}
